"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusButton = void 0;
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var clsx_1 = __importDefault(require("clsx"));
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        success: {
            backgroundColor: palette.success.main,
            "&:hover, &$focusVisible": {
                backgroundColor: colorManipulator_1.lighten(palette.success.main, palette.action.hoverOpacity),
            },
        },
        warning: {
            backgroundColor: palette.warning.main,
            color: palette.warning.contrastText,
            "&:hover,  &$focusVisible": {
                backgroundColor: colorManipulator_1.lighten(palette.warning.main, palette.action.hoverOpacity),
            },
        },
        error: {
            backgroundColor: palette.error.main,
            "&:hover,  &$focusVisible": {
                backgroundColor: colorManipulator_1.lighten(palette.error.main, palette.action.hoverOpacity),
            },
        },
    });
}, { name: "EuiStatusButton" });
exports.StatusButton = React.forwardRef(function StatusButton(_a, ref) {
    var _b = _a.color, color = _b === void 0 ? "success" : _b, className = _a.className, props = __rest(_a, ["color", "className"]);
    var classes = useStyles();
    return (React.createElement(core_1.Button, __assign({ className: clsx_1.default(classes[color], className) }, props, { variant: "contained", ref: ref })));
});
//# sourceMappingURL=StatusButton.js.map